import { IconWarningCircle16, UIText3 } from '@cian/ui-kit';
import classNames from 'clsx';
import * as React from 'react';

import * as styles from './Pessimization.css';
import { EPessimizationBackground, IPessimization } from '../../../../types';

interface IPessimizationProps {
  pessimization: IPessimization;
}

export const Pessimization: React.FC<React.PropsWithChildren<IPessimizationProps>> = ({
  pessimization: { background, text },
  children,
}) => {
  return (
    <div className={styles['container']}>
      {children}
      <div
        className={classNames(styles['banner'], {
          [styles['banner--red']]: background === EPessimizationBackground.Red,
        })}
      >
        <IconWarningCircle16 display="block" color="white_100" />
        <UIText3 as="p" color="white_100" textAlign="center">
          {text}
        </UIText3>
      </div>
    </div>
  );
};
